import { lazy } from 'react';
import { HiOutlineBanknotes, HiOutlineDocumentText, HiOutlineCalculator, HiOutlineBuildingStorefront, HiOutlineChartBar } from 'react-icons/hi2';
import type { ModuleManifest } from '../types';

const FinanceLayout = lazy(() => import('./components/FinanceLayout'));
const BudgetPage = lazy(() => import('./components/BudgetPage'));
const FinancialPlanPage = lazy(() => import('./components/FinancialPlanPage'));
const TaxModelingPage = lazy(() => import('./components/TaxModelingPage'));
const InvestmentProgramPage = lazy(() => import('./components/InvestmentProgramPage'));
const HRM2ReportPage = lazy(() => import('./components/HRM2ReportPage'));

export const financeManifest: ModuleManifest = {
  name: 'finance',
  featureFlag: 'module_finance',
  label: 'Public Finance',
  icon: HiOutlineBanknotes,
  basePath: 'finance',
  navItems: [
    { key: 'fin-budgets', label: 'Budgets', icon: HiOutlineBanknotes, path: '/app/finance/budgets', matchFn: (p) => p.startsWith('/app/finance/budgets') },
    { key: 'fin-plans', label: 'Financial Plan', icon: HiOutlineChartBar, path: '/app/finance/plans', matchFn: (p) => p.startsWith('/app/finance/plans') },
    { key: 'fin-tax', label: 'Tax Modeling', icon: HiOutlineCalculator, path: '/app/finance/tax-models', matchFn: (p) => p.startsWith('/app/finance/tax') },
    { key: 'fin-invest', label: 'Investments', icon: HiOutlineBuildingStorefront, path: '/app/finance/investments', matchFn: (p) => p.startsWith('/app/finance/investments') },
    { key: 'fin-hrm2', label: 'HRM2 Reports', icon: HiOutlineDocumentText, path: '/app/finance/hrm2', matchFn: (p) => p.startsWith('/app/finance/hrm2') },
  ],
  routes: [
    {
      path: 'finance',
      component: FinanceLayout,
      children: [
        { path: 'budgets', component: BudgetPage },
        { path: 'plans', component: FinancialPlanPage },
        { path: 'tax-models', component: TaxModelingPage },
        { path: 'investments', component: InvestmentProgramPage },
        { path: 'hrm2', component: HRM2ReportPage },
      ],
    },
  ],
};
